export default __webpack_public_path__ + "static/media/cv.af3471f4.svg";